import React from 'react';
import { AccessoryPacksCarousel } from '~/pages/model-accessories/components/accessory-packs-carousel';
import { AccessoryPack } from '~/common/models';

type AccessoryCarouselWrapperProp = { accessoryPacks: AccessoryPack[] };
export const AccessoryPacksCarouselWrapper =
  React.memo<AccessoryCarouselWrapperProp>(({ accessoryPacks }) => {
    return <AccessoryPacksCarousel accessoryPacks={accessoryPacks} />;
  });
